import { Audio, AudioTypesDDL } from 'types/audio';
import { BaseSongListQueryParams, Song } from 'types/song';
import { GenericObject } from 'types/generic.types';
import { Link } from 'types/api.types';
import { ReleaseType } from 'types/releases';

export enum AudioValidationErrorCodes {
  CONTAINER_IS_NOT_SUPPORTED = 'ContainerIsNotSupported',
  DURATION_IS_TOO_SMALL = 'DurationIsTooSmall',
  SAMPLE_RATE_IS_TOO_LOW = 'SampleRateIsTooLow',
  BITS_PER_SAMPLE_IS_TOO_LOW = 'BitsPerSampleIsTooLow',
  CHANNEL_COUNT_IS_NOT_SUPPORTED = 'ChannelCountIsNotSupported',
  BIT_RATE_IS_TOO_LOW = 'BitRateIsTooLow',
}

export interface AudioSelectionItem extends Audio {
  songDetails: Pick<Song, 'status' | 'title'>;
}

export interface SelectedAudio {
  audioGuid: string;
  songGuid: string;
  songTitle: string;
  audioTitle: string;
  type: string;
}

export type SelectedAudioObject = GenericObject<SelectedAudio>;

export type ValidationContext = ReleaseType.TUNECORE | ReleaseType.LABEL_V2;

export interface FetchAudioOptions {
  next?: Link;
  initial?: boolean;
  search?: string;
  isRootFunctionCall?: boolean;
  validationContext?: ValidationContext;
  filters: { types?: string[]; onlyLatestVersionAudio: boolean };
}

export interface AudioListFilters {
  types: string[];
  onlyLatestVersionAudio: boolean;
}

export interface AudioSelectListProps {
  loading: boolean;
  loadingMore: boolean;
  hasMore?: boolean;
  setChecked: (state: SelectedAudioObject) => void;
  checked: SelectedAudioObject;
  fetchMore: () => Promise<void | null>;
  audioList: AudioSelectionItem[];
  maxAudioCount?: number;
  audioTypes: AudioTypesDDL;
  onMaxAudioFilesSelected: () => void;
  emptyStateMessage: string;
  search: string;
  onCancel: () => void;
  onAdd: () => void;
  onSearch: (search: string) => void;
  isSubmitting: boolean;
  songAudioListValidation?: BaseSongListQueryParams | undefined;
  disabledAudios?: { audios: string[]; reason: string };
  onInvalidAudioSelect?: (errorCode: AudioValidationErrorCodes) => void;
  filters: AudioListFilters;
  onFilter: (filters: Partial<AudioListFilters>) => void;
}
